import { useEffect } from "react";
import { Row, Col, Button, Input, Typography } from "antd";
import { SearchOutlined, MenuOutlined } from "@ant-design/icons";

function Header({ subName, onPress }) {
  const { Title } = Typography;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Row gutter={[24, 0]} align="middle">
      {/* PAGE TITLE */}
      <Col span={24} md={12}>
        <Title level={4} style={{ margin: 0, textTransform: "capitalize" }}>
          {subName
            ?.replace(/_/g, " ")          // replace underscores with spaces
            .replace(/\b\w/g, (c) => c.toUpperCase())}
        </Title>
      </Col>


      {/* ACTIONS */}
      <Col span={24} md={12} style={{ textAlign: "right" }}>
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          style={{ width: 220, marginRight: 12 }}
        />

        {/* <Button type="text" onClick={onPress} icon={<MenuOutlined />} /> */}
      </Col>
    </Row>
  );
}

export default Header;
